import { combineReducers } from '@reduxjs/toolkit';

import {
  appointmentBooking,
  browserAutoFill,
  components,
  cookies,
  cpcCard,
  crmAutoFill,
  dataMappings,
  dynamicHeight,
  errors,
  events,
  experimentation,
  features,
  formConfig,
  legalStatement,
  logRocket,
  lottieAnimationData,
  navigation,
  navigationControls,
  newsletter,
  oneTrustLocale,
  optionalFormConfig,
  paging,
  persistKeyboard,
  publicKeys,
  sessionDataPopulation,
  submission,
  submissionStatus,
  supplierMatches,
  theme,
  transition,
  trustedForm,
  userIdentities,
} from '../slices';

const rootReducer = combineReducers({
  appointmentBooking,
  browserAutoFill,
  components,
  cookies,
  cpcCard,
  crmAutoFill,
  dataMappings,
  dynamicHeight,
  errors,
  events,
  experimentation,
  features,
  formConfig,
  legalStatement,
  logRocket,
  lottieAnimationData,
  navigation,
  navigationControls,
  newsletter,
  oneTrustLocale,
  optionalFormConfig,
  paging,
  persistKeyboard,
  publicKeys,
  sessionDataPopulation,
  submission,
  submissionStatus,
  supplierMatches,
  theme,
  transition,
  trustedForm,
  userIdentities,
});

export default rootReducer;
